var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.422,
    height: 14.478,
    viewBox: "0 0 14.422 14.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#208ce1;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.741,14.262h1.58a6.147,6.147,0,0,1,1.449,3.977,6.222,6.222,0,0,1-.191,1.536L34.04,17.453H32.534l-.65-.978v-.788Zm-5.1-1.855v.561l1.5,2.255-1.127,1.87H27.9l-.856-1.285-.877,1.45,1.274,1.91H29.55l.8,1.2v.377L28.77,21.875l-1.293,2.139a6.26,6.26,0,0,1-.841-.392V19.273l-1.768-2.655H23.7A6.158,6.158,0,0,1,27.644,12.407Zm5.929,11.887a7.2,7.2,0,1,0-3.953,1.188,7.144,7.144,0,0,0,3.247-.779Z",
    transform: "translate(-22.411 -11.003)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/globe_icon.488542005303ff62e296a1f52df4d254.svg";
export { ForwardRef as ReactComponent };